export function featureTableClampableText() {
    Alpine.data('featureTableClampableText', () => ({
        expanded: false,
        clamped: false,

        init() {
            this.mq = window.matchMedia('(min-width: 1024px)');
            this.checkClamped = () => {
                this.clamped = this.mq.matches
                    && this.$refs.text.scrollHeight > this.$refs.text.clientHeight + 1;
            };

            this.$nextTick(() => this.checkClamped());
            this.mq.addEventListener('change', this.checkClamped);
        },

        toggle() {
            this.expanded = !this.expanded;
            this.$nextTick(() => {
                if (!this.expanded) {
                    this.checkClamped();
                }
            });
        },
    }));
}
